import { i18n } from "@lingui/core";
import React from 'react';
import { Trans } from '@lingui/react';
import { useAppConfiguration } from '@wkda/funnel-components';

// check if the translation is an actual value or a placeholder
function isSubtitle(subTitle) {
  return !subTitle.includes('subtitle');
}
export default function FormHeader() {
  var subTitle = i18n._(
  /*i18n*/
  {
    id: 'carleadCreation.form.subtitle'
  });
  var _useAppConfiguration = useAppConfiguration(),
    locale = _useAppConfiguration.locale;
  return /*#__PURE__*/React.createElement("header", {
    className: "carlead-creation-form__header mb-4"
  }, /*#__PURE__*/React.createElement("h1", null, /*#__PURE__*/React.createElement(Trans, {
    id: "carleadCreation.form.mainTitle",
    components: [/*#__PURE__*/React.createElement("br", {
      className: "d-none d-md-block"
    })]
  })), isSubtitle(subTitle) && locale === 'sv-SE' && /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Trans, {
    id: "carleadCreation.form.subtitle"
  })));
}